module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedt"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("FOR OTTO PENZLER")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Though we talk of all Time smothers,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And all that Age affrights,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Yet with joy in one another,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Laugh through these New York nights.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352d5584","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 72
// module chunks = 0